import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
	selector: 'app-empty-container',
	template: `<router-outlet></router-outlet>`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [RouterOutlet]
})
export class EmptyContainerComponent {}